import { IconsId } from 'assets/font-icons-generated/icons';
import React, { CSSProperties } from 'react'; 
import 'assets/font-icons-generated/icons.css';
interface Props {
  icon: IconsId;
  style?: CSSProperties;
}

/**
 * Draws icons batched into the font file.
 * See Source/EPDServices.Web/epdportal-icons/ project for more details.
 */
const FontIcon: React.FC<Props> = ({ icon, style }) => {
  return <i className={`icon icon-${icon}`} style={{ ...style }} />;
};

export default FontIcon;
